import { ComponentProps, FC } from 'react';

import { StyledDiv } from './styles';

interface IStopPointIconProps extends ComponentProps<'svg'> {
	disabled?: boolean;
}

export const StopPointIcon: FC<IStopPointIconProps> = ({
	disabled,
	...props
}) => (
	<StyledDiv disabled={disabled}>
		<svg
			height="330"
			width="330"
			xmlns="http://www.w3.org/2000/svg"
			xmlSpace="preserve"
			viewBox="0 0 330 330"
			{...props}
		>
			<path
				fill="currentColor"
				d="M165 0C74.019 0 0 74.019 0 165s74.019 165 165 165 165-74.019 165-165S255.982 0 165 0zm0 300c-74.439 0-135-60.56-135-135S90.561 30 165 30s135 60.561 135 135-60.561 135-135 135z"
			/>
		</svg>
	</StyledDiv>
);
